import Maintenance from './MaintenancePage'

export default Maintenance;
